import React, { useState } from "react";

import { IoChevronBackSharp } from "react-icons/io5";

import "./mob-navigation.styles.css";

const MobNavigation = ({ isOpen }) => {
  const [activeItem, setActiveItem] = useState(null);

  const toggleSubMenu = (index) => {
    setActiveItem(activeItem === index ? null : index);
  };

  const menuData = [
    {
      title: "خانه",
      link: "/",
      subItems: [],
    },
    {
      title: "دراپ",
      link: "/drop",
      subItems: [],
    },
    {
      title: "فروشگاه",
      link: "/shop-page",
      subItems: [],
    },
  ];

  return (
    <div className={`mob-menu ${isOpen ? "open" : ""}`}>
      <ul className="mob-menu-list">
        {menuData.map((item, index) => (
          <li key={index} className="mob-menu-item">
            <a href={item.link} className="menu-title">
              <span className={`arrow ${activeItem === index ? "open" : ""}`}>
                <IoChevronBackSharp />
              </span>
              {item.title}
            </a>
            {activeItem === index && (
              <ul className="sub-menu">
                {item.subItems.map((subItem, subIndex) => (
                  <li key={subIndex} className="sub-menu-item">
                    <a href={subItem.link}>{subItem.title}</a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobNavigation;
